var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSecure3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.75,51.84375V10A.7502.7502,0,0,0,64,9.25H16a.7502.7502,0,0,0-.75.75V51.84375A12.71277,12.71277,0,0,0,22.96875,63.606l16.73926,7.085a.75109.75109,0,0,0,.584,0l16.73926-7.085A12.712,12.712,0,0,0,64.75,51.84375ZM40,69.18555,23.55273,62.22412A11.21489,11.21489,0,0,1,16.75,51.84375V10.75h46.5V51.84375a11.21413,11.21413,0,0,1-6.80273,10.38037Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56,31.25H50.75V26a10.75,10.75,0,0,0-21.5,0v5.25H24a.7502.7502,0,0,0-.75.75V54a.7502.7502,0,0,0,.75.75H56a.7502.7502,0,0,0,.75-.75V32A.7502.7502,0,0,0,56,31.25ZM30.75,26a9.25,9.25,0,0,1,18.5,0v5.25H30.75Zm24.5,27.25H24.75V32.75h30.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure3);
export default __webpack_public_path__ + "static/media/icon_secure_3.928ac15b6bb51711215e28a3c056eb63.svg";
export { ForwardRef as ReactComponent };